import axios from 'axios';
import { config } from '../utils/customLocalStorage';

const apiUrl = process.env.REACT_APP_BACKEND_URL || "https://not_set";

const dynamicAPI = async (method, url, obj = {}) => {
    const isFormData = obj instanceof FormData;
    const cfg = config();
    const uploadCfg = isFormData
        ? { headers: { ...cfg.headers, 'Content-Type': undefined } }
        : cfg;

    try {
        let response;
        switch (method) {
            case 'get':
                response = await axios.get(`${apiUrl}${url}`, cfg);
                break;
            case 'post':
                response = await axios.post(`${apiUrl}${url}`, obj, uploadCfg);
                break;
            case 'put':
                response = await axios.put(`${apiUrl}${url}`, obj, uploadCfg);
                break;
            case 'delete':
                response = await axios.delete(`${apiUrl}${url}`, cfg);
                break;
            default:
                throw new Error('Invalid method');
        }
        return {
            ...response.data,
            status: response.status,
            isSuccess: true,
        };
    } catch (error) {
        console.error('BAD ERROR', error);
        const errorMessage = error.response?.data?.error || 'An unexpected error occurred.';
        if (error.response?.status === 401) {
            console.error('UNAUTHORIZED ERROR:', errorMessage);
            localStorage.removeItem('userInfo');
            localStorage.removeItem('userRole');
        }
        if (error.response?.status === 403) {
            console.error('UNAUTHORIZED PERMISSION:', error);
            throw {
                error: errorMessage,
                status: error.response?.status,
                isError: true,
                isSuccess: false
            };
        }
        // Rethrow the error so it can be caught in the `onError` of the mutation.
        // Pass the raw response body through as `data` too, so callers can read
        // structured fields (e.g. a 409 conflict's `code`/`conflict`) and not
        // just the flattened message string.
        throw {
            error: errorMessage,
            status: error.response?.status || 500,
            data: error.response?.data,
            isError: true,
            isSuccess: false,
        };
    }
};

// Fetch a protected file (served only to an authenticated owner/admin) as a
// Blob, using the Bearer token, and open it in a new browser tab. Needed for
// files that are no longer public URLs — a plain <a href> can't send the auth
// header. Returns the created object URL (caller may revoke it later).
export const openAuthedFile = async (url) => {
    const cfg = config();
    const response = await axios.get(`${apiUrl}${url}`, {
        ...cfg,
        responseType: 'blob',
    });
    const blobUrl = URL.createObjectURL(response.data);
    window.open(blobUrl, '_blank', 'noopener,noreferrer');
    // Give the new tab time to load before releasing the object URL.
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
    return blobUrl;
};

// Fetch a protected file as a Blob and save it under `fileName` (download
// instead of opening a tab). Same auth handling as openAuthedFile.
export const downloadAuthedFile = async (url, fileName = 'download') => {
    const cfg = config();
    const response = await axios.get(`${apiUrl}${url}`, {
        ...cfg,
        responseType: 'blob',
    });
    const blobUrl = URL.createObjectURL(response.data);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
};

export default dynamicAPI;
